import { Fragment } from "react/jsx-runtime";
import RadioSkeleton from "./RadioSkeleton";
import TextInputSkeleton from "./TextInputSkeleton";
import AddressSkeleton from "./AddressSkeleton";
import TextAreaSkeleton from "./TextAreaSkeleton";
import DatePickerSkeleton from "./DatePickerSkeleton";

function FormLoader() {
  return (
    <Fragment>
      <RadioSkeleton />
      <TextInputSkeleton />
      <RadioSkeleton />
      <RadioSkeleton />
      <AddressSkeleton />
      <TextAreaSkeleton />
      <DatePickerSkeleton />
    </Fragment>
  );
}

export default FormLoader;
